import React from 'react'
import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { useCallback, useState } from 'react'
import { useMediaQuery } from '@mantine/hooks'
import styles from './kdt-dataanalysis-5th.module.scss'

interface ICurriculumMAccordionProps {
  contents: {
    step: string
    title: string
    contents: {
      contentsIntro: string
      contentsInner: string[]
    }[]
  }
  idx: number
}

const CurriculumAccordion = ({ contents, idx }: ICurriculumMAccordionProps) => {
  const isMobile = useMediaQuery('(max-width: 1023px)')
  const defaultOpen = idx === 0
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const onOpenHandler = useCallback(() => {
    setIsOpen(!isOpen)
  }, [isOpen])

  return (
    <li
      className="mb-3 overflow-hidden rounded-lg bg-trueGray-800 last-of-type:mb-0"
      onClick={onOpenHandler}
    >
      <div className="flex w-full cursor-pointer items-center justify-between gap-x-3 px-4 py-3">
        <div className="flex flex-col gap-2">
          <p className="text-xs font-bold text-yellow-450">{contents.step}</p>
          <p
            className={`${
              isOpen ? 'text-white' : 'text-label-alternative'
            } whitespace-pre-wrap text-base font-bold`}
          >
            {contents.title}
          </p>
        </div>
        <ChevronDownIcon
          className={`${
            isOpen ? 'rotate-180 transform text-white' : 'text-label-alternative'
          } ml-auto h-auto w-4 shrink-0 grow-0`}
        />
      </div>
      {/* Open */}
      {isOpen && (
        <div className="flex w-full flex-1 flex-col gap-3 px-4 pb-4">
          {contents.contents.map(content => (
            <div key={content.contentsIntro} className="flex w-full flex-col gap-3">
              <p className="text-sm leading-normal text-white">{content.contentsIntro}</p>
              {content.contentsInner && (
                <ul className="flex w-full flex-col">
                  {content.contentsInner.map(inner => (
                    <li className="border-t border-[#404040] py-2 last-of-type:pb-0" key={inner}>
                      <p
                        className={`${styles.text_dot} ${styles.text_dot_section5} text-sm leading-normal text-label-assistive`}
                      >
                        {inner}
                      </p>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      )}
    </li>
  )
}

export default CurriculumAccordion
